import { elements, modifiers } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { videoOnly } from '#utilities/js/media/constraints.js'
import { get } from '#utilities/js/media/stream.js'
import * as utilities from '#utilities/js/styles.js'

export const initCamera = async (wrapper) => {
  const { ownerDocument } = wrapper
  const { window } = defaults
  const video = one(`.${elements.device_camera_video}`, wrapper)
  const media = await get(window, videoOnly)
  const buttonSnap = one('button[name="snap"]', wrapper)
  const buttonReset = one('button[name="reset"]', wrapper)
  const off = one(`.${modifiers.device_camera.off}`, ownerDocument)
  const on = one(`.${modifiers.device_camera.on}`, ownerDocument)

  if (off && on && video && media) {
    off.classList.add(utilities.modifiers.display.none)

    if (on.classList.contains(utilities.modifiers.display.none)) {
      on.classList.remove(utilities.modifiers.display.none)
    }
    video.srcObject = media
    video.play()
  }

  if (buttonSnap) {
    snap.listen(buttonSnap)
  }

  if (buttonReset) {
    reset.listen(buttonReset)
  }
}

const snap = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const wrapper = closest(`[data-show-xfiles='camera']`, button)

    if (wrapper) {
      const video = one(`.${elements.device_camera_video}`, wrapper)
      const canvas = one(`.${elements.device_camera_canvas}`, wrapper)
      const buttonReset = one('button[name="reset"]', wrapper)
      const field = one('[type="hidden"][name="upload_camera_data"]', wrapper)

      if (video) {
        const { videoWidth, videoHeight } = video
        const data = canvas.toDataURL()
        canvas.width = videoWidth
        canvas.height = videoHeight
        canvas.getContext('2d').drawImage(video, 0, 0, videoWidth, videoHeight)
        video.classList.toggle(utilities.modifiers.display.none)
        canvas.classList.toggle(utilities.modifiers.display.none)

        if (buttonReset) {
          buttonReset.classList.toggle(utilities.modifiers.display.none)
        }
        button.classList.toggle(utilities.modifiers.display.none)

        if (field && data) {
          field.value = data
        }
      }
    }
  }
})

export const reset = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const wrapper = closest(`[data-show-xfiles='camera']`, button)

    if (wrapper) {
      const video = one(`.${elements.device_camera_video}`, wrapper)
      const canvas = one(`.${elements.device_camera_canvas}`, wrapper)

      if (video && canvas) {
        video.classList.toggle(utilities.modifiers.display.none)
        canvas.classList.toggle(utilities.modifiers.display.none)

        const buttonSnap = one('button[name="snap"]', wrapper)
        if (buttonSnap) {
          buttonSnap.classList.toggle(utilities.modifiers.display.none)
        }
        button.classList.toggle(utilities.modifiers.display.none)

        const field = one('[type="hidden"][name="upload_camera_data"]', wrapper)
        if (field) {
          field.value = ''
        }
      }
    }
  }
})

export default async wrapper => {
  initCamera(wrapper)
}